<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>施工管理</el-breadcrumb-item>
            <el-breadcrumb-item>开单[{{ kaidan_title }}]</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card>
            <div class="kaidan_body">
                <div v-if="true" class="left01">
                    <el-steps :active="cardShow - 1" align-center direction="vertical">
                        <el-step title="车辆信息" description="车辆信息" @click.native="menu_set(1)"></el-step>
                        <el-step title="外观信息" description="外观信息" @click.native="menu_set(2)"></el-step>
                        <el-step title="客户信息" description="客户信息" @click.native="menu_set(3)"></el-step>
                        <el-step title="订单信息" description="订单信息" @click.native="menu_set(4)"></el-step>
                        <el-step title="支付账单" description="支付账单" @click.native="menu_set(5)"></el-step>
                    </el-steps>
                </div>
                <div style="width: 100%;" class="kaidan">
                    <div class="kaidan">
                        <el-card v-if="cardShow_xianshi === 1" class="card_style">
                            <div v-if="cardShow_sub === 1"> <el-form ref="paizhaoRef" :model="queryInfoChepai"
                                    :rules="paizhaoRules" label-width="100px">
                                    <el-form-item label="车辆牌照：" prop="paizhao" style="font-size: 30px;">
                                        <el-input v-model="queryInfoChepai.paizhao" placeholder="请输入车牌"
                                            style="font-size: larger;"></el-input>
                                    </el-form-item>
                                </el-form>
                            </div>
                            <div v-if="cardShow_sub === 2">
                                <!-- 开单调用 ，在此处车辆添加，无需通过响应事件返回数据，直接由回调返回-->
                                <cheliangAdd ref="cheliangAddRef" :paizhao="queryInfoChepai.paizhao" :diaoyongType="2"
                                    :caozuoType="1" :editUid="0">
                                </cheliangAdd>
                            </div>
                            <div v-if="cardShow_sub === 3">
                                <cheliangAdd ref="cheliangAddRef" :paizhao="queryInfoChepai.paizhao" :diaoyongType="2"
                                    :editUid="addForm.cheliang_uid" :caozuoType="2">
                                </cheliangAdd>
                            </div>

                        </el-card>
                        <el-card v-if="cardShow_xianshi === 2" class="card_style">
                            <!-- 外观只需要添加，无需在此修改 所以 caozuoType 1   diaoyongType 2-开单-->
                            <div v-if="cardShow_sub === 1">
                                <waiguanAdd ref="waiguanAddRef" :diaoyongType="2" :key="datekey" :editUid="0"
                                    :cheliang_uid="addForm.cheliang_uid" :caozuoType="1">
                                </waiguanAdd>
                            </div>
                        </el-card>
                        <el-card v-if="cardShow_xianshi === 3" class="card_style">
                            <div v-if="cardShow_sub === 1">
                                <el-form ref="guestMobTestRef" :model="queryInfoGuestMob" :rules="guestMobTestRefRules"
                                    label-width="100px">
                                    <el-form-item label="客户手机" prop="guestMob">
                                        <el-input v-model="queryInfoGuestMob.guestMob"></el-input>
                                    </el-form-item>

                                </el-form>
                            </div>
                            <div v-if="cardShow_sub === 2" style="height: 600px;">
                                <!-- 直接通过回调函数获取客户信息，无需通过事件响应 -->
                                <guestAdd ref="guestAddRef" :guestMob="queryInfoGuestMob.guestMob" :diaoyongType="2"
                                    :key="datekey" :caozuoType="1" :editUid="0">
                                </guestAdd>
                            </div>
                            <div v-if="cardShow_sub === 3">
                                <guestAdd ref="guestAddRef" :guestMob="queryInfoGuestMob.guestMob" :diaoyongType="2"
                                    :key="datekey" :caozuoType="2" :editUid="addForm.guest_uid">
                                </guestAdd>
                            </div>
                        </el-card>
                        <el-card v-if="cardShow_xianshi === 4" class="card_style">
                            <div v-if="cardShow_sub === 1">
                                <chukuDo :kaidanFlag="1" :dataParent="addForm" ref="chukuDoRef" :diaoyongType="2"
                                    :mendianUid="mendianUid" :productTypeSelect="9" > </chukuDo>
                            </div>
                            <div v-if="cardShow_sub === 2">
                                <Func ref="kaidanFuncRef" :orderInfo="addForm" show_type="cheliang_info" :diaoyongType="2"></Func>
                            </div>
                        </el-card>
                    </div>
                </div>
            </div>
        </el-card>
        <div style="margin-top: 10px;text-align: center;"><span slot="footer" class="dialog-footer">
                <el-button @click="quxiao">取 消</el-button>
                <el-button type="primary" @click="addorder"  :disabled="add_isDisable">{{ button_text
                }}</el-button>
            </span> </div>
    </div>
</template>
<script>
import { checkMobileTest, checkSfzId } from '../config/validator';
import cheliangAdd from './cheliang_add.vue'
import guestAdd from './guest_add.vue'
import chukuDo from './chuku_do.vue'
import Func from './func.vue'
import waiguanAdd from './waiguan_add.vue'
export default {
    components: {
        cheliangAdd: cheliangAdd,
        guestAdd: guestAdd,
        chukuDo: chukuDo,
        Func: Func,
        waiguanAdd: waiguanAdd
    },
    data() {
        return {
            mendianUid: 0,
            errFlag: 0,
            datekey: Date.now(),
            // editUid_cheliang: 0, // 修改uid
            car_update_flag: 0, // 是否为新添加 车辆资料 1 新车型 2 已有车型
            guest_update_flag: 0, // 是否为新添加客户， 1位新客户 2为已有客户
            array_cardShow_sub: [],
            kaidan_title: '01-01:请输入车牌',
            button_text: '下一步',
            isCollapse002: true,
            cardShow: 1, // 主模块控制标记
            cardShow_sub: 1, // 子元素显示标记
            cardShow_xianshi: 1, // 用于显示
            isCollapse: true,
            order_options: [
                {
                    value: 1,
                    label: '初级订单'
                },
                {
                    value: 2,
                    label: '中级订单'
                },
                {
                    value: 3,
                    label: '高级订单'
                }
            ],
            // 获取用户列表参数
            queryInfo: {
                C_type: 'get_list',
                C_table_name: 'order_list',
                query: '',
                pageNum: 1,
                pageSize: 10,
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            queryInfoChepai: {
                C_type: 'query_paizhao',
                paizhao: '苏J' // '苏J123456'
                // qiye_uid: window.sessionStorage.getItem('qiye_uid') // 车牌信息通用，可以不用企业标识
            },

            waiGuanAddForm: {
                bianhao: '',
                waiguan_memo: '',
                qiye_uid: window.sessionStorage.getItem('qiye_uid')
            },
            queryInfoGuestMob: {
                C_type: 'query_guestMob',
                guestMob: '',
                qiye_uid: window.sessionStorage.getItem('qiye_uid') // 客户查询信息通用，可以不用企业标识
            },

            huifang_isDisable: false,
            add_isDisable: false,
            orderList: [],
            //  recordCount: 0,
            total: 0,
            addDialogVisible: false,
            editDialogVisible: false,
            huifangDialogVisible: false,

            // 用于设置回访页面滑块值
            //  添加表单数据项
            huifangForm: {
                C_type: 'huifang_add',
                huifang_order_uid: 0,
                huifang_title: '',
                hufiang_memo: '',
                huifang_genjin: 1,
                huifang_yuangong_uid: 0,
                huifang_switch: true
            },
            addFormInit: {
                // 在每个业务流程中，都保存每个业务的重要数据
                C_type: 'order_add',
                kaidanFlag: 1, // 用于传递 到出库页面 ，区别仓库出库功能
                order_bianhao: '',
                // *****选择获得*******
                cheliang_uid: 0,
                guest_uid: 0,
                waiguan_uid: 0,
                chukudan_uid: 0,
                // ************
                cheliang_info: {},
                guest_info: {},
                waiguan_info: {},
                chukudan_info: {},
                order_info: {}
            },
            addForm: {
                // 在每个业务流程中，都保存每个业务的重要数据
                C_type: 'order_add',
                kaidanFlag: 1, // 用于传递 到出库页面 ，区别仓库出库功能
                order_bianhao: '',
                // *****选择获得*******
                cheliang_uid: 0,
                guest_uid: 0,
                waiguan_uid: 0,
                chukudan_uid: 0,
                guest_order_mob: '',
                // ************
                cheliang_info: {},
                guest_info: {},
                waiguan_info: {},
                chukudan_info: {},
                order_info: {}
            },
            // 表单规则项
            guestMobTestRefRules: {
                guestMob: [
                    {
                        validator: checkMobileTest.bind(
                            this.queryInfoGuestMob && this.queryInfoGuestMob.guestMob
                        )
                    }
                    // { required: true, message: '请输入手机号码', trigger: 'blur' },
                    // { min: 11, max: 11, message: '必须是11位字符! ', trigger: 'blur' }
                ]
            },
            paizhaoRules: {
                paizhao: [
                    { required: true, message: '请输入牌照', trigger: 'blur' },
                    { min: 7, max: 8, message: '必须是6-7位字符! ', trigger: 'blur' }
                ]
            },
            addFormRules: {
                order_name: [
                    { required: true, message: '请输入订单名称', trigger: 'blur' },
                    { min: 2, max: 20, message: '必须2到20位字符 ', trigger: 'blur' }
                ],

                order_mob: [
                    {
                        validator: checkMobileTest.bind(
                            this.addForm && this.addForm.order_mob
                        )
                    }
                ],
                order_sfz_bianhao: [
                    {
                        validator: checkSfzId.bind(
                            this.addForm && this.addForm.order_sfz_bianhao
                        )
                    }
                ]
            },
            editCheliangRules: {},
            huifangFormRefRules: {
                huifang_title: [
                    { required: true, message: '请输入回访标题', trigger: 'blur' },
                    { min: 1, max: 1000, message: '必须1位字符 ', trigger: 'blur' }
                ]
            },
            waiGuanAddFormRules: {}
        };
    },
    created() {
        // this.getorderList();
        console.log('强制刷新')
        this.getBianhao_order()
        this.mendianUid = window.sessionStorage.getItem('qiye_uid')
        console.log(999, window.sessionStorage.getItem('qiye_uid'))
    },
    methods: {
        menu_set(type) {
            // console.log(type)
            if (this.cardShow >= type) {
                this.kaidan_title_set(type)
                this.cardShow_xianshi = type
                this.cardShow = type
                this.cardShow_sub = 1
            }
        },
        quxiao() {
            this.$emit('kaidan_addClose', 0)
        },
        async getBianhao_waiguan() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 15 }
            });
            this.waiGuanAddForm.bianhao = JSON.parse(res.data)[0].bianhao_l;
        },
        async getBianhao_order() {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_type: 'get_bianhao', C_table_type: 16 }
            });
            this.addForm.order_bianhao = JSON.parse(res.data)[0].bianhao_l;
            this.kaidan_title_set(1)
        },
        getCarTypeSelectedUid(uid) {
            console.log('chexingUid', uid)
            this.editCheliangForm.chexing_uid = uid
        },
        SelectType(type) {
            this.cheliangSelectType = type
        },
        getGuestInfo(data) {
            this.addForm.guest_uid = data.guestUid // 新添加的客户，要通过子组件上报获得,修改的车辆直接通过页面获得
            this.addForm.guest_info = data
        },
        getCheliangNewUid(CheliangNewUid) {
            // console.log(1000)
            // console.log('cheliangUid', CheliangNewUid)
            this.addForm.cheliang_uid = CheliangNewUid // 新添加的车辆，要通过子组件上报获得,修改的车辆直接通过页面获得
        },

        get_switch_value(switchValue) {
            this.huifangForm.huifang_genjin = switchValue ? 1 : 0;
            console.log(this.huifangForm.huifang_genjin);
        },
        async huiFangAdd() {
            const { data: res } = await this.$http.post('api', this.huifangForm);
            console.log(JSON.parse(res.data)[0].bianhao_s);
            this.huifangDialogVisible = true;
        },
        async get_order_add() {
            this.cardShow = 1
            this.cardShow_xianshi = 1
            this.cardShow_sub = 1
            await this.getBianhao_order()
            this.kaidan_title_set()
            this.addDialogVisible = true;
        },
        async getorderList() {
            const { data: res } = await this.$http.get('get_api', {
                params: this.queryInfo
            });
            // console.log(JSON.parse(res.data))
            this.orderList = JSON.parse(res.data)[0].dataList;

            if (!this.orderList) return;
            this.orderList.forEach(function (item) {
                item.yong_flag = item.yong_flag === 1;
            });

            this.total = JSON.parse(res.data)[0].total;

            // console.log(this.total)
        },
        //  分页第一项下拉触发

        handleSizeChange(newSize) {
            this.queryInfo.pageSize = newSize;
            this.getorderList();
        },
        // 选择页数触发
        handleCurrentChange(newPage) {
            this.queryInfo.pageNum = newPage;
            this.getorderList();
        },
        kaidan_title_set(type) {
            console.log('当前位置', this.cardShow_xianshi, this.cardShow, this.cardShow_sub)
            if (type === 1) {
                this.cardShow_xianshi = this.cardShow
                this.array_cardShow_sub[this.cardShow - 1] = this.cardShow_sub
            }
            var bianhaoTitle = this.kaidan_title = ' -> 订单编号：[' + this.addForm.order_bianhao + ']'
            if ((this.cardShow_xianshi === 1) && (this.cardShow_sub === 1)) this.kaidan_title = ' 01-01:请输入车牌' + bianhaoTitle
            if ((this.cardShow_xianshi === 1) && (this.cardShow_sub === 2)) this.kaidan_title = ' 01-02:请录入车辆信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 1) && (this.cardShow_sub === 3)) this.kaidan_title = ' 01-03:请确认车辆信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 2) && (this.cardShow_sub === 1)) this.kaidan_title = ' 02-01:车辆外观检查' + bianhaoTitle
            if ((this.cardShow_xianshi === 3) && (this.cardShow_sub === 1)) this.kaidan_title = ' 03-01:输入客户手机号码' + bianhaoTitle
            if ((this.cardShow_xianshi === 3) && (this.cardShow_sub === 2)) this.kaidan_title = ' 03-02:请录入客户信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 3) && (this.cardShow_sub === 3)) this.kaidan_title = ' 03-03:请确认客户信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 4) && (this.cardShow_sub === 1)) this.kaidan_title = ' 04-01:请录入订单信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 4) && (this.cardShow_sub === 2)) this.kaidan_title = ' 04-02:请确认订单信息' + bianhaoTitle
            if ((this.cardShow_xianshi === 5) && (this.cardShow_sub === 1)) this.kaidan_title = ' 05-01:订单支付信息' + bianhaoTitle
            return 0
        },
        test_pro() {
            console.log(8888, this.cardShow_xianshi, this.cardShow, this.cardShow_sub, this.addForm)
        },
        err_chuli(type, data) {
            if (data.uid === -1) {
                this.$message.error(type === 1 ? '车辆添加出错' : type === 2 ? '外观添加出错' : '客户添加出错')
                return 0
            }
        },
        async addorder() {
            this.add_isDisable = true
            setTimeout(() => {
                this.add_isDisable = false // 点击一次时隔两秒后才能再次点击
            }, 1000)
            this.cardShow_xianshi = this.cardShow
            if ((this.cardShow === 1) && (this.cardShow_sub === 1)) {
                this.$refs.paizhaoRef.validate(async valid => {
                    if (!valid) return 1;
                    if (this.cardShow_sub === 1) {
                        const { data: res } = await this.$http.post('api', this.queryInfoChepai);
                        if (JSON.parse(res.data)[0].status === 202) { // 没有车辆
                            this.cardShow_sub = 2 // 用于card显示哪个内容标记
                        } else if (JSON.parse(res.data)[0].status === 203) { //  有车辆，但是没有生成订单
                            // this.editCheliangForm = JSON.parse(res.data)[0].cheliang_info[0]
                            this.addForm.cheliang_uid = JSON.parse(res.data)[0].cheliang_info[0].uid
                            // this.addForm.guest_order_mob = JSON.parse(res.data)[0].cheliang_info[0].uid
                            // this.queryInfoGuestMob.guestMob = JSON.parse(res.data)[0].guest_order_mob
                            this.cardShow_sub = 3
                        } else if (JSON.parse(res.data)[0].status === 200) {
                            // this.editCheliangForm = JSON.parse(res.data)[0].cheliang_info[0]
                            this.addForm.cheliang_uid = JSON.parse(res.data)[0].cheliang_info[0].uid
                            // this.addForm.guest_order_mob = JSON.parse(res.data)[0].cheliang_info[0].uid
                            this.queryInfoGuestMob.guestMob = JSON.parse(res.data)[0].guest_order_mob // 直接读取客户手机号
                            this.cardShow_sub = 3
                        }
                        this.kaidan_title_set(1) 
                        this.test_pro()
                    }
                })
                return 0
            }
            if ((this.cardShow === 1) && (this.cardShow_sub === 2)) {
                await this.$refs.cheliangAddRef.add((errFlag, data) => {
                    if (errFlag === 1) return 0 // 有错误，就停下来
                    this.addForm.cheliang_info = data
                    this.addForm.cheliang_uid = data.uid
                    this.getBianhao_waiguan()
                    this.cardShow = 2
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                    this.kaidan_title_set(1)
                    this.test_pro()
                })
                // 调用子组件的添加按钮 ，进行车辆添加，需要返回车辆uid  在这个 getCheliangUid 中 通过发射事件返回
                // this.kaidan_title = '03:车辆外观检查'

                return 0
            }
            if ((this.cardShow === 1) && (this.cardShow_sub === 3)) {
                await this.$refs.cheliangAddRef.add((errFlag, data) => {
                    if (errFlag === 1) return 0 // 有错误，就停下来
                    this.addForm.cheliang_info = data
                    this.addForm.cheliang_uid = data.uid
                    this.getBianhao_waiguan()
                    this.cardShow = 2
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                    this.kaidan_title_set(1)
                    this.test_pro()
                })
                // 调用子组件的添加按钮 ，进行车辆添加，需要返回车辆uid  在这个 getCheliangUid 中 通过发射事件返回
                // this.kaidan_title = '03:车辆外观检查'

                return 0
            }
            if ((this.cardShow === 2) && (this.cardShow_sub === 1)) { // 外观递交
                await this.$refs.waiguanAddRef.add((errFlag, data) => {
                    console.log('外观错误读取', errFlag)
                    if (errFlag === 1) return 0
                    else this.errFlag = 0 // 标志清0
                    this.addForm.waiguan_info = data
                    this.addForm.waiguan_uid = data.uid
                    this.getBianhao_waiguan()
                    this.cardShow = 3
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                    // 显示手机查询页面时，就需要把手机号码填入输入框
                    
                    this.kaidan_title_set(1)
                    this.test_pro()
                })
                return 0
                // 调用子组件的添加按钮 ，进行车辆添加，需要返回车辆uid  在这个 getCheliangUid 中 通过发射事件返回
                // this.kaidan_title = '03:车辆外观检查'
            }
            // console.log(8181, this.cardShow, this.cardShow_sub)
            // this.test_pro()
            if ((this.cardShow === 3) && (this.cardShow_sub === 1)) { // 客户手机查询递交
                this.$refs.guestMobTestRef.validate(async valid => {
                    if (!valid) return 1;
                    console.log(981, this.queryInfoGuestMob)
                    const { data: res } = await this.$http.post('api', this.queryInfoGuestMob);
                    if (JSON.parse(res.data)[0].status === 202) {
                        // this.kaidan_title = '05-1:新录入客户信息'   
                        this.cardShow = 3
                        this.cardShow_xianshi = this.cardShow
                        this.cardShow_sub = 2
                    } else if (JSON.parse(res.data)[0].status === 200) {
                        this.addForm.guest_uid = JSON.parse(res.data)[0].guest_info[0].uid
                        this.cardShow = 3
                        this.cardShow_sub = 3
                    }
                    this.kaidan_title_set(1)
                    this.test_pro()
                })
                return 0
            }
            if ((this.cardShow === 3) && (this.cardShow_sub === 2)) {
                await this.$refs.guestAddRef.add((errFlag, data) => {
                    if (errFlag === 1) return 0 // 有错误，就停下来
                    this.addForm.guest_info = data
                    this.addForm.guest_uid = data.uid
                    this.cardShow = 4
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                    this.kaidan_title_set(1)
                    this.test_pro()
                    return 0
                })
                // this.kaidan_title = '04:录入订单'
                // this.getBianhao_waiguan()
            }
            if ((this.cardShow === 3) && (this.cardShow_sub === 3)) {
                await this.$refs.guestAddRef.add((errFlag, data) => {
                    if (errFlag === 1) return 0 // 有错误，就停下来
                    this.addForm.guest_info = data
                    this.addForm.guest_uid = data.uid
                    this.cardShow = 4
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 1
                    this.kaidan_title_set(1)
                    this.test_pro()
                })
                return 0
                // this.kaidan_title = '04:录入订单'
                // this.getBianhao_waiguan()
            }
            // console.log('test', this.cardShow, this.cardShow_sub)
            if ((this.cardShow === 4) && (this.cardShow_sub === 1)) {
                await this.$refs.chukuDoRef.product_kaidan((errFlag, data) => { // 通过data 回调 返回order_info 
                    if (errFlag === 1) return 0 // 有错误，就停下来等
                    console.log(909, data)
                    this.addForm.chukudan_info = data
                    this.addForm.order_info = data
                    this.cardShow = 4
                    this.cardShow_xianshi = this.cardShow
                    this.cardShow_sub = 2
                })
                return 0
                // 页面还没有加载所以报错
                // await this.$refs.kaidanFuncRef.getCheliangInfo(this.addForm.cheliang_uid)
                // console.log(this.addForm)
            }
            var errFlagPar = 0
            if ((this.cardShow === 4) && (this.cardShow_sub === 2)) {
                const comfirmResult = await this.$confirm(
                    '确定生成订单, 是否继续?',
                    '提示',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }
                ).catch(err => err);
                if (comfirmResult === 'cancel') return 0
                // 确认订单，出库  ,因为 到此出库页面的调用已经结束，不能调用出库页面函数，必须通过如下程序，读保存的数据写入数据库
                /*       var dataKucunChukudan = {
                           C_type: 'kucun_chukudan_add',
                           chukudan_bianhao: this.addForm.chukudan_info.chukudan_bianhao,
                           count: this.addForm.chukudan_info.count,
                           chuku_type: 1, // 销售出库
                           mendianUid: this.mendianUid
                       }
                       console.log(123)
                       const { data: res00 } = await this.$http.post('api', dataKucunChukudan)
                       if (JSON.parse(res00.data)[0].status !== 200) {
                           this.$message.error('出库失败');
                           return;
                       }
                       var chukudanUid = JSON.parse(res00.data)[0].chukudan_uid
                       this.addForm.chukudan_uid = chukudanUid // 下一个页面通过uid找出库单编号，统一标准
                       const obj00 = this.addForm.chukudan_info.chuku_pro_list
                       // console.log(obj00)
                       obj00.forEach((item, index) => {
                           const data = {
                               C_type: 'kucun_chuku_add',
                               pro_uid: item.pro_uid,
                               pro_count: item.pro_count,
                               chukudan_uid: chukudanUid,
                               mendianUid: this.mendianUid
                           }
                           const { data: res03 } = this.$http.post('api', data);
                       })
                       // 看分析文档，订单确认之后，才能进行出库操作，否则在此只能加入订单，确认时，由存储过程完成出入库
       */
                // 进行写数据库保存数据
                // 写addForm中的订单数据 
                var dataOrderAdd = {
                    C_type: 'order_add',
                    order_bianhao: this.addForm.order_bianhao,
                    order_money: this.addForm.order_info.order_money,
                    order_memo: this.addForm.order_info.order_memo,
                    cheliang_uid: this.addForm.cheliang_uid,
                    guest_uid: this.addForm.guest_uid,
                    waiguan_uid: this.addForm.waiguan_uid,
                    chukudan_uid: 0, // 订单中，出入库的uid 不记录，还没有哪 ，出库表中记录订单编号即可
                    cheliang_gonglishu: parseInt(this.addForm.cheliang_info.gonglishu),
                    kucun_uid: this.addForm.order_info.kucun_uid
                }
                console.log('addForm', this.addForm)
                const { data: res } = await this.$http.post('api', dataOrderAdd)
                if (JSON.parse(res.data)[0].status !== 200) {
                    this.$message.error('订单生成失败！');
                    return;
                }
                var orderUid = JSON.parse(res.data)[0].order_uid
                const obj = this.addForm.order_info.chuku_pro_list
                console.log(1001, obj)
                obj.forEach((item, index) => {
                    // 在保存订单的过程中，需要对商品中如果有会员套餐卡的项目进行单独处理，并进行充值，升级服务

                    const data = {
                        // 在此过程中，根据商品类型，如果是服务类的，直接生成服务订单
                        C_type: 'order_mingxi_add',
                        pro_uid: item.pro_uid,
                        pro_count: item.pro_count,
                        pro_price: item.pro_price,
                        order_uid: orderUid,
                        pro_code: 0,
                        kucun_uid: item.kucun_uid, // 库存uid 至关重要，通过该uid 才能准确的扣除库存
                        guest_uid: this.addForm.guest_uid
                    }
                    const { data: res02 } = this.$http.post('api', data, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    });
                    this.$nextTick()
                })
                this.$message.success('订单递交成功！');
                // this.input_init()
                this.test_pro()
                this.cardShow = 5
                this.cardShow_xianshi = this.cardShow
                this.cardShow_sub = 1

                this.$emit('orderOver', 0) // 发射事件关闭窗口
                return 0
            }
            if (0 && (this.cardShow === 5) && (this.cardShow_sub === 1)) { // 结账、及数据保存页面
                this.cardShow = 5
                this.cardShow_xianshi = this.cardShow
                this.cardShow_sub = 2
                this.test_pro()
                return 0
            }
        },
        input_init() {
            this.cardShow = 1
            this.cardShow_xianshi = 1
            this.cardShow_sub = 1
            // this.editForm = {}
            this.addForm = this.addFormInit
        },
        async getCheliangInfo() {
        },
        showEditDialog(uid) {
            this.orderInfo(uid);
            this.editDialogVisible = true;
        },
        addDoalogClosed() {
            // this.$refs.addFormRef.resetFields();
            this.input_init()
        },
        huifangDoalogClosed() {
            this.$refs.huifangFormRef.resetFields();
        },
        showHuifangDialog(uid) {
            this.huifangDialogVisible = true;
            this.orderInfo(uid);
        },
        editDoalogClosed() {
            this.$refs.editFormRef.resetFields();
        },
        async orderInfo(uid) {
            const { data: res } = await this.$http.get('get_api', {
                params: { C_table_name: 'order_info', uid: uid, C_type: 'get_info' }
            });
            // console.log(JSON.parse(res.data))
            // console.log(res.data);
            if (JSON.parse(res.data)[0].status !== 200) {
                return this.$message.error('读取失败');
            }

            this.editForm = JSON.parse(res.data)[0].data[0];
            this.huifangForm.huifang_order_uid = JSON.parse(res.data)[0].data[0].uid;
        },
        async updateorder() {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return this.$message.error('验证错误！');
                this.editForm.C_type = 'order_update';
                // 对象加入一个项C_type
                const { data: res } = await this.$http.post('api', {
                    C_type: 'order_update',
                    order_bianhao: this.editForm.order_bianhao.trim(),
                    order_name: this.editForm.order_name,
                    order_mob: this.editForm.order_mob,
                    order_addr: this.editForm.order_addr,
                    order_sfz_bianhao: this.editForm.order_sfz_bianhao,
                    order_level: this.editForm.order_level,
                    order_price_want: this.editForm.order_price_want,
                    order_yixiang: this.editForm.order_yixiang,
                    order_memo: this.editForm.order_memo,
                    order_laiyuan: this.editForm.order_laiyuan,
                    order_uid: this.editForm.uid
                });

                if (JSON.parse(res.data)[0].status !== 200) {
                    this.$message.error('更新失败');
                    return;
                }
                this.$message.success('更新成功');
                this.getorderList();
                this.editDialogVisible = false;
            });
        },
        // 删除一条记录
        async deleteForm(orderUid) {
            // 此处通过异步获取操作行为，而不用then ，来避免异步嵌套
            // 异步操作有2个，1个对话框等待，1个是网络请求
            const comfirmResult = await this.$confirm(
                '确定删除该条记录, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err);
            // console.log(comfirmResult);
            if (comfirmResult === 'cancel') return this.$message.info('已经取消删除');
            const { data: res } = await this.$http.post('api', {
                C_type: 'record_delete',
                C_table_name: 'order_del',
                C_data1: orderUid
            });
            if (JSON.parse(res.data)[0].status !== 200) {
                this.$message.error('删除失败');
                return;
            }
            this.$message.success('删除成功');
            this.getorderList();
        }
    }
};
</script>
<style lang="less" scoped>
.card_two {
    margin-top: 30px;
    box-shadow: none !important;
    background-color: #f2f6fc;
}

.el_row_two {
    margin-top: 30px;
    height: 650px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 200px;
    min-height: 400px;
}

.left01 {
    min-width: 120px;
}

.kaidan {
    display: flex;
    flex-direction: column;

}

.card_style {
    height: 700px;
    overflow-y: auto;
}

.kaidan_title {
    background-color: #eee;
    width: 100%;
    height: 40px;
    font-size: 30px;
    color: black;
    border-radius: 5px 5px 0px 0px;
    text-align: center;
    padding-top: 8px;
}

.kaidan_body {
    display: flex;
    flex-direction: row;
    height: 700px;

}

.card_gundong {
    overflow-y: auto;
    max-height: 500px;
    max-width: 500px;
}

.bgshuzi {
    background-color: #f39c9c;
}
</style>
